var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noticeData)?_c('Component' + _vm.noticeData.type,{tag:"component",attrs:{"notice-data":_vm.noticeData,"is-vertical":_vm.isVertical,"is-complete":_vm.isComplete}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }